// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"608ed891","126":"32a369f4","492":"2f9a31d9","608":"74ce19d2","787":"48345d20","797":"9f80b603"}[chunkId] + ".chunk.js";
};